module.exports = __webpack_public_path__ + "fbc1734b0619e2a107b906f2f697973b.svg";